module.exports = __webpack_public_path__ + "view/2019/img/arrow_right_he.png";